import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { hydrateSessionFromRefresh, initializeAuthSession } from './utils/authSession'
import AppErrorBoundary from './components/AppErrorBoundary'

initializeAuthSession();

async function bootstrapApp() {
  try {
    await hydrateSessionFromRefresh();

    const rootElement = document.getElementById('root');
    if (!rootElement) {
      throw new Error('Root element not found');
    }

    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <AppErrorBoundary>
          <App />
        </AppErrorBoundary>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Failed to render app:', error);
    document.body.innerHTML = `
      <div style="padding: 2rem; text-align: center; font-family: Arial, sans-serif;">
        <h1>Application Error</h1>
        <p>Failed to load the application. Please check the console for details.</p>
        <pre style="background: #f5f5f5; padding: 1rem; text-align: left; overflow: auto;">${error.toString()}</pre>
      </div>
    `;
  }
}

bootstrapApp();
